import React, { FC } from 'react';
import { Card, CardHeader, CardContent, CardActions, Button } from 'ceci-ui';
import { OnboardingIconWrapper } from './styles';
import CheckIcon from '@material-ui/icons/Check';

export type Props = {
  done?: boolean;
  disabled?: boolean;
  step: number;
  title: string;
  content: string;
  buttonProps?: any;
}

const OnboardingCard: FC<Props> = (props) => {
  const avatar = (
    <OnboardingIconWrapper
      done={props.done}
      disabled={props.disabled}>

      {props.done ? <CheckIcon /> : props.step}
    </OnboardingIconWrapper>
  );

  const variant = props.done || props.disabled ? 'outlined' : 'contained';

  return (
    <Card variant="outlined">
      <CardHeader
        title={props.title}
        avatar={avatar} />
      <CardContent>
        <p>{props.content}</p>
      </CardContent>
      <CardActions>
        <Button variant={variant} size="small" disabled={props.disabled} {...props.buttonProps} />
      </CardActions>
    </Card>

  );
};

export default OnboardingCard;
